export const environment = 'dev'

export const tradingApi = 'https://api.rhinofi.dev'

export const multiCallDoNotAggregate = ['BINANCE']

export const LEGACY_RHINO_CLAIMS = {
  TAIKO: [1, 3, 4],
}

export const LEGACY_CROSS_CHAIN_SWAP_CONTRACTS = [
  { chain: 'ARBITRUM_MAINNET', contractAddress: '0x0bca65bf4b4c8803d2f0b49353ed57caaf3d66dc' },
  { chain: 'BINANCE_MAINNET', contractAddress: '0x0bca65bf4b4c8803d2f0b49353ed57caaf3d66dc' },
  { chain: 'POLYGON_MAINNET', contractAddress: '0x0bca65bf4b4c8803d2f0b49353ed57caaf3d66dc' },
]
